import React, { useEffect, useState } from "react";
import ManageHeader from "@components/ManageHeader";
import { ScrollText } from "lucide-react";
import { useTranslation } from "react-i18next";
import InvoiceForm from "./forms/InvoiceForm";
import { dateFrEn, firstDayCurrentMonth } from "@global/actions";
import { apiSend, getRoute } from "@services/axios";
import Paginate from "@components/Paginate";
import Listing from "./components/Listing";
import { Col, Row } from "react-bootstrap";

function Home(props) {
  const { t } = useTranslation();

  const [invoiceNumber, setInvoiceNumber] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [invoiceList, setInvoiceList] = useState([]);
  const [total, setTotal] = useState(0);
  const [dateFrom, setDateFrom] = useState(firstDayCurrentMonth());
  const [dateTo, setDateTo] = useState(new Date().toLocaleDateString("fr-FR"));

  const handleInvoiceNumber = (event) => {
    setInvoiceNumber(event.target.value);
  };
  const onChangeDate = (from, to) => {
    setDateFrom(from);
    setDateTo(to);
  };

  const loadData = async (page) => {
    window.loader(1);
    const payload = {
      invoiceNumber: invoiceNumber,
      status: selectedStatus?.value,
      dateFrom: dateFrEn(dateFrom),
      dateTo: dateFrEn(dateTo),
    };

    const response = await apiSend(
      getRoute("INVOICE_LIST") + "?page=" + page,
      "post",
      payload
    );

    if (response?.data?.result?.total > 0) {
      setInvoiceList(response?.data?.result.data);
      setTotal(response?.data?.result?.total);
    } else {
      setInvoiceList([]);
      setTotal(0);
    }
    window.loader(0);
  };

  useEffect(() => {
    const timerId = setTimeout(async () => {
      await loadData(0);
    }, 2000);
    return () => {
      clearTimeout(timerId);
    };
  }, []);

  return (
    <>
    <div className="table-container p-4 bg-white rounded-4 shadow">
      <InvoiceForm
        invoiceNumber={invoiceNumber}
        setInvoiceNumber={setInvoiceNumber}
        handleInvoiceNumber={handleInvoiceNumber}
        dateFrom={dateFrom}
        dateTo={dateTo}
        onChangeDate={onChangeDate}
        selectedStatus={selectedStatus}
        setSelectedStatus={setSelectedStatus}
        loadData={loadData}
      />

      <Header t={t} />
      <Paginate
        total={total}
        itemsPerPage={20}
        loadData={loadData}
        component={
          <Listing t={t} mode={props.profile.mode} data={invoiceList} />
        }
      />
    </div>

      
    </>
  );
}
export default Home;

const Header = ({ t }) => {
  return (
    <div key="header" className="my-1 p-3   text-white sticky bg-blue">
      <Row className="align-items-center">
        <Col md="2">
          <div className="fs-6 fw-bold">{t("ho_act_facturation_num")}</div>
        </Col>
        <Col md="2">
          <div className="fs-6 fw-bold">
            {t("ho_act_facturation_datefacture")}
          </div>
        </Col>
        <Col md="2">
          <div className="fs-6 fw-bold">{t("amount")}</div>
        </Col>
        <Col md="2">
          <div className="fs-6 fw-bold">{t("status")}</div>
        </Col>
        <Col md="2">
          <div className="fs-6 fw-bold">
            {t("ho_act_facturation_datePaiement")}
          </div>
        </Col>

        <Col md="2"></Col>
      </Row>
    </div>
  );
};
